import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Clear static SSR shell before React renders (SSR content stays in raw HTML for crawlers)
if (rootElement.hasChildNodes()) {
  rootElement.innerHTML = '';
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
